module.exports = __webpack_public_path__ + "img/setting-w.8637176b.svg";